import { render, staticRenderFns } from "./GamanzaWidgetPage.vue?vue&type=template&id=bfaa8f94&scoped=true"
import script from "./GamanzaWidgetPage.vue?vue&type=script&lang=js"
export * from "./GamanzaWidgetPage.vue?vue&type=script&lang=js"
import style0 from "./GamanzaWidgetPage.vue?vue&type=style&index=0&id=bfaa8f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfaa8f94",
  null
  
)

export default component.exports